import { NgModule, APP_INITIALIZER } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FEATURE_FLAG_PROVIDER } from './feature-flag.provider';
import { FlagsmithProvider } from './flagsmith.provider';
import { SlFlagDirective } from './sl-flag.directive';

export function initializeFeatureFlags(provider: FlagsmithProvider) {
  return () => provider.init();
}

@NgModule({
  declarations: [
    SlFlagDirective
  ],
  imports: [
    CommonModule
  ],
  providers: [
    {
      provide: FEATURE_FLAG_PROVIDER,
      useClass: FlagsmithProvider
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeFeatureFlags,
      deps: [FlagsmithProvider],
      multi: true
    }
  ],
  exports: [
    SlFlagDirective
  ]
})
export class FeatureFlagModule { }
